<template>
	<div class="container">
		<div class="filter-container">
			<el-select v-model="selectCountry" multiple placeholder="请选择" style="width: 200px">
				<el-option v-for="item in countryList" :key="item.code" :label="item.name" :value="item.name"> </el-option>
			</el-select>
			<el-button type="primary" icon="el-icon-search" @click="handleSubmit">{{ langTxt('保存') }}</el-button>
		</div>
		<el-table v-loading="listLoading" :data="dataListCountry" border fit highlight-current-row :height="height">
			<el-table-column show-overflow-tooltip :label="langTxt('国家')" prop="name"></el-table-column>
		</el-table>
	</div>
</template>
<script>
	export default {
		name: 'DomainList',

		data() {
			return {
				dialogStatus: '',
				dialogFormVisible: false,
				form: {
					addCountryList: []
				},
				list: null,
				listLoading: false,
				__i18n: {},
				countryList: [], // 保存国家列表数据
				dataListCountry: [],
				selectCountry: '', // 过滤选择的国家列表
				addCountryList: [] // 新增的国家列表
			};
		},

		computed: {
			height() {
				return this.$baseTableHeight();
			}
		},

		created() {
			this.getCountryList();
			this.getDataList();
			this.__i18n = this.$i18n.messages[this._i18n.locale];
		},

		methods: {
			// 获取国家列表
			getCountryList() {
				const params = {
					key: 'COUNTRY'
				};
				this.request.get('/system', { params }).then((res) => {
					this.countryList = res.country;
				});
			},

			getDataList() {
				this.listLoading = true;

				this.request.get('/admin-info').then((res) => {
					let white_country = res.info.admin_u_kf.white_country;

					if (white_country.includes(',')) {
						this.dataListCountry = white_country.split(',').map((item) => (item = { name: item }));
					} else {
						if (white_country) {
							this.dataListCountry = [{ name: white_country }];
						} else {
							this.dataListCountry = [];
						}
					}
				});
				this.listLoading = false;
			},

			handleSubmit() {
				const data = {
					country: this.selectCountry.join(',')
				};
				this.request.post('/country-add', data).then(() => {
					this.tipMsg();
					this.selectCountry = [];
					this.getDataList();
				});
			},

			// 提示
			tipMsg() {
				setTimeout(() => {
					this.$baseNotify(this.langTxt('保存成功'), 'success', 'success'); // message, title, type
				}, 200);
			},

			close() {
				this.dialogFormVisible = false;
			}
		}
	};
</script>
